/**
 * 模块: 关键词表格列定义 - 统一入口
 * 职责: 组合所有关键词表格列配置
 * 限制: <280行
 */

import type { ColumnsType } from 'antd/es/table';
import { basicColumns } from './basicColumns';
import { replacementColumns } from './replacementColumns';
import { shareColumns } from './shareColumns';
import { scoreColumns } from './scoreColumns';
import { marketColumns } from './marketColumns';
import { createAIActionColumns } from './aiActionColumns';

/**
 * 关键词表格完整列配置
 */
export const keywordColumns: ColumnsType<any> = [
  ...basicColumns,
  ...replacementColumns,
  ...shareColumns,
  ...scoreColumns,
  ...marketColumns,
];

/**
 * 导出 AI 操作列创建函数
 */
export { createAIActionColumns };

